module.exports = __webpack_public_path__ + "static/img/service-01.e406557c.png";